"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get binaryExpressionBuilder () {
        return binaryExpressionBuilder;
    },
    get callExpressionBuilder () {
        return callExpressionBuilder;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _formulaFnHelper = require("src/helpers/formulaFnHelper");
const _mapFunctionName = /*#__PURE__*/ _interop_require_default(require("../mapFunctionName"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const assignFnName = (pt)=>{
    if (pt.fnName) return;
    if (pt.dataType === _nocodbsdk.FormulaDataTypes.STRING) {
        pt.fnName = 'CONCAT';
    } else {
        pt.fnName = 'ARITH';
    }
};
const callExpressionBuilder = async ({ context, pt, fn, prevBinaryOp, aliasToColumn, knex, model, columnIdToUidt })=>{
    switch(pt.callee.name.toUpperCase()){
        case 'ADD':
        case 'SUM':
            if (pt.arguments.length > 1) {
                return fn({
                    type: _nocodbsdk.JSEPNode.BINARY_EXP,
                    operator: '+',
                    left: {
                        type: _nocodbsdk.JSEPNode.CALL_EXP,
                        callee: {
                            type: 'Identifier',
                            name: 'COALESCE'
                        },
                        arguments: [
                            pt.arguments[0],
                            {
                                type: _nocodbsdk.JSEPNode.LITERAL,
                                value: 0
                            }
                        ]
                    },
                    right: _extends({}, pt, {
                        arguments: pt.arguments.slice(1)
                    })
                }, prevBinaryOp);
            } else {
                return fn({
                    type: _nocodbsdk.JSEPNode.CALL_EXP,
                    callee: {
                        type: 'Identifier',
                        name: 'COALESCE'
                    },
                    arguments: [
                        pt.arguments[0],
                        {
                            type: _nocodbsdk.JSEPNode.LITERAL,
                            value: 0
                        }
                    ]
                }, prevBinaryOp);
            }
            break;
        case 'CONCAT':
            if (knex.clientType() === 'sqlite3') {
                if (pt.arguments.length > 1) {
                    return fn({
                        type: _nocodbsdk.JSEPNode.BINARY_EXP,
                        operator: '||',
                        left: pt.arguments[0],
                        right: _extends({}, pt, {
                            arguments: pt.arguments.slice(1)
                        })
                    }, prevBinaryOp);
                } else {
                    return fn(pt.arguments[0], prevBinaryOp);
                }
            } else if (knex.clientType() === 'databricks') {
                const res = await (0, _mapFunctionName.default)({
                    pt,
                    knex,
                    aliasToCol: aliasToColumn,
                    fn,
                    prevBinaryOp,
                    model
                });
                if (res) return res;
            }
            break;
        case 'URL':
            /**
       * Added extra whitespace around URI and LABEL content to avoid conflicts during regex parsing.
       *
       * Reason for Adding Whitespace:
       * - Our URI syntax uses parentheses `(` and `)` to wrap URL and label content.
       * - Escaped parentheses `\(` and `\)` are allowed inside content, but without extra space,
       *   trailing backslashes (e.g., `\)`) near the closing parenthesis can cause incomplete group matches.
       * - Adding leading and trailing spaces around the content (`URI::( ` and ` )`) ensures that
       *   closing parentheses after escaped characters are parsed correctly.
       *
       * Example Case:
       * - Without space: `URI::(https://github.com/nocodb/nocodb/pull/10707\)`
       *   - Results in incomplete or invalid group matches.
       * - With space: `URI::( https://github.com/nocodb/nocodb/pull/10707\ )`
       *   - Handles escaped characters and parses content as expected.
       *
       * How It Works:
       * - The backend adds a leading space after `URI::(` and before the closing `)`.
       * - For labels, a leading space is added after `LABEL::(` and before `)`.
       * - The frontend regex is updated to accommodate these changes.
       *
       */ return fn({
                type: _nocodbsdk.JSEPNode.CALL_EXP,
                arguments: [
                    {
                        type: _nocodbsdk.JSEPNode.LITERAL,
                        value: 'URI::( ',
                        raw: '"URI::( "'
                    },
                    // wrap with replace function to escape parenthesis since it has special meaning in our URI syntax
                    {
                        type: _nocodbsdk.JSEPNode.CALL_EXP,
                        arguments: [
                            {
                                type: _nocodbsdk.JSEPNode.CALL_EXP,
                                arguments: [
                                    pt.arguments[0],
                                    {
                                        type: _nocodbsdk.JSEPNode.LITERAL,
                                        value: '(',
                                        raw: '"("'
                                    },
                                    {
                                        type: _nocodbsdk.JSEPNode.LITERAL,
                                        value: '\\(',
                                        raw: '"\\("'
                                    }
                                ],
                                callee: {
                                    type: 'Identifier',
                                    name: 'REPLACE'
                                }
                            },
                            {
                                type: _nocodbsdk.JSEPNode.LITERAL,
                                value: ')',
                                raw: '")"'
                            },
                            {
                                type: _nocodbsdk.JSEPNode.LITERAL,
                                value: '\\)',
                                raw: '"\\)"'
                            }
                        ],
                        callee: {
                            type: 'Identifier',
                            name: 'REPLACE'
                        }
                    },
                    {
                        type: _nocodbsdk.JSEPNode.LITERAL,
                        value: ' )',
                        raw: '" )"'
                    },
                    ...pt.arguments[1] ? [
                        {
                            type: _nocodbsdk.JSEPNode.LITERAL,
                            value: ' LABEL::( ',
                            raw: ' LABEL::( '
                        },
                        // wrap with replace function to escape parenthesis since it has special meaning in our URI syntax
                        {
                            type: _nocodbsdk.JSEPNode.CALL_EXP,
                            arguments: [
                                {
                                    type: _nocodbsdk.JSEPNode.CALL_EXP,
                                    arguments: [
                                        pt.arguments[1],
                                        {
                                            type: _nocodbsdk.JSEPNode.LITERAL,
                                            value: '(',
                                            raw: '"("'
                                        },
                                        {
                                            type: _nocodbsdk.JSEPNode.LITERAL,
                                            value: '\\(',
                                            raw: '"\\("'
                                        }
                                    ],
                                    callee: {
                                        type: 'Identifier',
                                        name: 'REPLACE'
                                    }
                                },
                                {
                                    type: _nocodbsdk.JSEPNode.LITERAL,
                                    value: ')',
                                    raw: '")"'
                                },
                                {
                                    type: _nocodbsdk.JSEPNode.LITERAL,
                                    value: '\\)',
                                    raw: '"\\)"'
                                }
                            ],
                            callee: {
                                type: 'Identifier',
                                name: 'REPLACE'
                            }
                        },
                        {
                            type: _nocodbsdk.JSEPNode.LITERAL,
                            value: ' )',
                            raw: '" )"'
                        }
                    ] : []
                ],
                callee: {
                    type: 'Identifier',
                    name: 'CONCAT'
                }
            }, prevBinaryOp);
            break;
        default:
            {
                const res = await (0, _mapFunctionName.default)({
                    pt,
                    knex,
                    aliasToCol: aliasToColumn,
                    fn,
                    prevBinaryOp,
                    model
                });
                if (res) return res;
            }
            break;
    }
    const calleeName = pt.callee.name.toUpperCase();
    const callArgs = (await Promise.all(pt.arguments.map(async (arg)=>{
        let query = (await fn(arg)).builder.toQuery();
        if (calleeName === 'CONCAT') {
            if (knex.clientType() !== 'sqlite3') {
                query = await (0, _formulaFnHelper.convertDateFormatForConcat)(context, arg, columnIdToUidt, query, knex.clientType());
            } else {
            // sqlite3: special handling - See BinaryExpression
            }
            if (knex.clientType() === 'mysql2') {
                // mysql2: CONCAT() returns NULL if any argument is NULL.
                // adding IFNULL to convert NULL values to empty strings
                return `IFNULL(${query}, '')`;
            } else {
            // do nothing
            // pg: Concatenate all arguments. NULL arguments are ignored.
            // sqlite3: special handling - See BinaryExpression
            }
        }
        return query;
    }))).join();
    return {
        builder: knex.raw(`${calleeName}(${callArgs})`.replace(/\?/g, '\\?'))
    };
};
const binaryExpressionBuilder = async ({ context, pt, fn, prevBinaryOp, knex, columnIdToUidt, aliasToColumn, model })=>{
    // treat `&` as shortcut for concat
    if (pt.operator === '&') {
        return fn({
            type: _nocodbsdk.JSEPNode.CALL_EXP,
            arguments: [
                pt.left,
                pt.right
            ],
            callee: {
                type: 'Identifier',
                name: 'CONCAT'
            }
        }, prevBinaryOp);
    }
    // if operator is + and expected return type is string, convert to concat
    if (pt.operator === '+' && pt.dataType === _nocodbsdk.FormulaDataTypes.STRING) {
        return fn({
            type: _nocodbsdk.JSEPNode.CALL_EXP,
            arguments: [
                pt.left,
                pt.right
            ],
            callee: {
                type: 'Identifier',
                name: 'CONCAT'
            }
        }, prevBinaryOp);
    }
    // if operator is == or !=, then handle comparison with BLANK which should accept NULL and empty string
    if (pt.operator === '==' || pt.operator === '!=') {
        var _pt_left_callee, _pt_right_callee;
        for (const operand of [
            'left',
            'right'
        ]){
            if (pt[operand].dataType === _nocodbsdk.FormulaDataTypes.BOOLEAN && pt[operand === 'left' ? 'right' : 'left'].dataType === _nocodbsdk.FormulaDataTypes.NUMERIC) {
                pt[operand === 'left' ? 'right' : 'left'] = {
                    type: _nocodbsdk.JSEPNode.CALL_EXP,
                    arguments: [
                        pt[operand === 'left' ? 'right' : 'left']
                    ],
                    callee: {
                        type: 'Identifier',
                        name: 'BOOLEAN'
                    },
                    dataType: _nocodbsdk.FormulaDataTypes.BOOLEAN
                };
            }
        }
        if (((_pt_left_callee = pt.left.callee) == null ? void 0 : _pt_left_callee.name) !== ((_pt_right_callee = pt.right.callee) == null ? void 0 : _pt_right_callee.name)) {
            // if left/right is BLANK, accept both NULL and empty string
            for (const operand of [
                'left',
                'right'
            ]){
                if (pt[operand].type === 'CallExpression' && pt[operand].callee.name === 'BLANK') {
                    const isString = pt[operand === 'left' ? 'right' : 'left'].dataType === _nocodbsdk.FormulaDataTypes.STRING;
                    let calleeName;
                    if (pt.operator === '==') {
                        calleeName = isString ? 'ISBLANK' : 'ISNULL';
                    } else {
                        calleeName = isString ? 'ISNOTBLANK' : 'ISNOTNULL';
                    }
                    return fn({
                        type: _nocodbsdk.JSEPNode.CALL_EXP,
                        arguments: [
                            operand === 'left' ? pt.right : pt.left
                        ],
                        callee: {
                            type: 'Identifier',
                            name: calleeName
                        }
                    }, prevBinaryOp);
                }
            }
        }
    }
    if (pt.operator === '==') {
        pt.operator = '=';
        // if left/right is of different type, convert to string and compare
        if (pt.left.dataType !== pt.right.dataType && [
            pt.left.dataType,
            pt.right.dataType
        ].every((type)=>type !== _nocodbsdk.FormulaDataTypes.NULL)) {
            pt.left = {
                type: _nocodbsdk.JSEPNode.CALL_EXP,
                arguments: [
                    pt.left
                ],
                callee: {
                    type: 'Identifier',
                    name: 'STRING'
                }
            };
            pt.right = {
                type: _nocodbsdk.JSEPNode.CALL_EXP,
                arguments: [
                    pt.right
                ],
                callee: {
                    type: 'Identifier',
                    name: 'STRING'
                }
            };
        }
    }
    if (pt.operator === '/') {
        pt.left = {
            callee: {
                name: 'FLOAT'
            },
            type: _nocodbsdk.JSEPNode.CALL_EXP,
            arguments: [
                pt.left
            ]
        };
        pt.right = {
            callee: {
                name: 'FLOAT'
            },
            type: _nocodbsdk.JSEPNode.CALL_EXP,
            arguments: [
                pt.right
            ]
        };
    }
    assignFnName(pt.left);
    assignFnName(pt.right);
    let left = (await fn(pt.left, pt.operator)).builder.toQuery();
    let right = (await fn(pt.right, pt.operator)).builder.toQuery();
    let sql = `${left} ${pt.operator} ${right}`;
    if (_nocodbsdk.ComparisonOperators.includes(pt.operator)) {
        // comparing a date with empty string would throw
        // `ERROR: zero-length delimited identifier` in Postgres
        if (knex.clientType() === 'pg' && columnIdToUidt[pt.left.name] === _nocodbsdk.UITypes.Date) {
            // The correct way to compare with Date should be using
            // `IS_AFTER`, `IS_BEFORE`, or `IS_SAME`
            // This is to prevent empty data returned to UI due to incorrect SQL
            if (pt.right.value === '') {
                if (pt.operator === '=') {
                    sql = `${left} IS NULL `;
                } else {
                    sql = `${left} IS NOT NULL `;
                }
            } else if (!(0, _nocodbsdk.validateDateWithUnknownFormat)(pt.right.value)) {
                // left tree value is date but right tree value is not date
                // return true if left tree value is not null, else false
                sql = `${left} IS NOT NULL `;
            }
        }
        if (knex.clientType() === 'pg' && columnIdToUidt[pt.right.name] === _nocodbsdk.UITypes.Date) {
            // The correct way to compare with Date should be using
            // `IS_AFTER`, `IS_BEFORE`, or `IS_SAME`
            // This is to prevent empty data returned to UI due to incorrect SQL
            if (pt.left.value === '') {
                if (pt.operator === '=') {
                    sql = `${right} IS NULL `;
                } else {
                    sql = `${right} IS NOT NULL `;
                }
            } else if (!(0, _nocodbsdk.validateDateWithUnknownFormat)(pt.left.value)) {
                // right tree value is date but left tree value is not date
                // return true if right tree value is not null, else false
                sql = `${right} IS NOT NULL `;
            }
        }
    }
    if (pt.left.fnName === 'CONCAT' && knex.clientType() === 'sqlite3') {
        var _pt_left_arguments, _pt_left, _pt_right_arguments, _pt_right;
        // handle date format
        left = await (0, _formulaFnHelper.convertDateFormatForConcat)(context, (_pt_left = pt.left) == null ? void 0 : (_pt_left_arguments = _pt_left.arguments) == null ? void 0 : _pt_left_arguments[0], columnIdToUidt, left, knex.clientType());
        right = await (0, _formulaFnHelper.convertDateFormatForConcat)(context, (_pt_right = pt.right) == null ? void 0 : (_pt_right_arguments = _pt_right.arguments) == null ? void 0 : _pt_right_arguments[0], columnIdToUidt, right, knex.clientType());
        // handle NULL values when calling CONCAT for sqlite3
        sql = `COALESCE(${left}, '') ${pt.operator} COALESCE(${right},'')`;
    }
    if (knex.clientType() === 'mysql2') {
        sql = `IFNULL(${left} ${pt.operator} ${right}, ${pt.operator === '=' ? pt.left.type === 'Literal' ? pt.left.value === '' : pt.right.value === '' : pt.operator === '!=' ? pt.left.type !== 'Literal' ? pt.left.value === '' : pt.right.value === '' : 0})`;
    } else if (knex.clientType() === 'sqlite3' || knex.clientType() === 'pg') {
        if (pt.operator === '=') {
            if (pt.left.type === 'Literal' && pt.left.value === '') {
                sql = `${right} IS NULL OR CAST(${right} AS TEXT) = ''`;
            } else if (pt.right.type === 'Literal' && pt.right.value === '') {
                sql = `${left} IS NULL OR CAST(${left} AS TEXT) = ''`;
            }
        } else if (pt.operator === '!=') {
            if (pt.left.type === 'Literal' && pt.left.value === '') {
                sql = `${right} IS NOT NULL AND CAST(${right} AS TEXT) != ''`;
            } else if (pt.right.type === 'Literal' && pt.right.value === '') {
                sql = `${left} IS NOT NULL AND CAST(${left} AS TEXT) != ''`;
            }
        }
        if ((pt.operator === '=' || pt.operator === '!=') && prevBinaryOp !== 'AND' && prevBinaryOp !== 'OR') {
            sql = `(CASE WHEN ${sql} THEN true ELSE false END )`;
        } else if (pt.operator === '/') {
            // handle divide by zero
            const right = await callExpressionBuilder({
                context,
                pt: {
                    callee: {
                        name: 'NULLIF',
                        type: 'Identifier'
                    },
                    dataType: _nocodbsdk.FormulaDataTypes.NUMERIC,
                    type: _nocodbsdk.JSEPNode.CALL_EXP,
                    arguments: [
                        pt.right,
                        {
                            type: _nocodbsdk.JSEPNode.LITERAL,
                            dataType: _nocodbsdk.FormulaDataTypes.NUMERIC,
                            value: 0,
                            raw: '0'
                        }
                    ]
                },
                fn,
                prevBinaryOp,
                aliasToColumn,
                knex,
                model,
                columnIdToUidt
            });
            sql = `${left} ${pt.operator} ${right.builder}`;
        } else {
            sql = `${sql} `;
        }
    }
    const query = knex.raw(sql.replace(/\?/g, '\\?'));
    if (prevBinaryOp && pt.operator !== prevBinaryOp) {
        query.wrap('(', ')');
    }
    return {
        builder: query
    };
};
